import React, {useState} from "react";
import {Button, TextField} from "@mui/material";
import {useSnackbar} from 'notistack';
import Grid from '@mui/material/Grid';
import {useNavigate} from "react-router-dom";
import {registerUser} from "../../utils/Api";
import FormWrapper from "../../components/PaperFormWrapper/PaperFormWrapper";

export const NewUserContainer = () => {
    const navigate = useNavigate();
    const {enqueueSnackbar} = useSnackbar();
    const [email, setEmail] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [loading, setLoading] = useState(false);

    // Notification helper - pops up error message
    const toastHelper = (msg, type) => {
        enqueueSnackbar(msg, {
            preventDuplicate: true,
            variant: type,
            anchorOrigin: {horizontal: 'right', vertical: 'bottom'}
        });
    }


    const handleEmailInput = (event) => {
        setEmail(event.target.value)
    };

    const handleFirstNameInput = (event) => {
        setFirstName(event.target.value)
    };

    const handleLastNameInput = (event) => {
        setLastName(event.target.value)
    };

    const handlePasswordInput = (event) => {
        setPassword(event.target.value);
    };

    const handlePasswordConfirmInput = (event) => {
        setPasswordConfirm(event.target.value);
    };

    const handleRegisterUser = async (event) => {
        event.preventDefault();
        setLoading(true);
        if (password !== passwordConfirm) {
            toastHelper("New password and confirm password were not the same! Please re-input desired password.", "error");
        } else {
            try {
                await registerUser({
                    "email": email.toLowerCase(),
                    "password": password,
                    "first_name": firstName,
                    "last_name": lastName
                });
                toastHelper("User Account Registered! Once verified, you will be able to login to the Vertical Knowledge Portal.", "success");
                navigate('/login/');
            } catch (e) {
                toastHelper("Unable to create your account!", "error");
            }
            setLoading(false);

        }
    };


    return (
        <FormWrapper title="Register" titleLinkTo={"/login"} titleLinkLabel="Already have an account?"
                     loading={loading} onSubmit={handleRegisterUser}>
            <Grid container columnSpacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        size="small"
                        margin="normal"
                        required
                        fullWidth
                        name="firstName"
                        label="First Name"
                        type="text"
                        id="firstName"
                        onChange={handleFirstNameInput}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        size="small"
                        margin="normal"
                        required
                        fullWidth
                        name="lastName"
                        label="Last Name"
                        type="text"
                        id="lastName"
                        onChange={handleLastNameInput}
                    />
                </Grid>
            </Grid>
            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="email"
                label="Email"
                type="email"
                id="email"
                onChange={handleEmailInput}
            />

            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password (8 characters min.)"
                type="password"
                id="password"
                onChange={handlePasswordInput}
            />

            <TextField
                size="small"
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                id="confirmPassword"
                onChange={handlePasswordConfirmInput}
            />


            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{mt: 3}}
                disabled={loading || (firstName === "" || lastName === "" || email === "" || password === "" || passwordConfirm === "")}
            >
                Create Account
            </Button>
        </FormWrapper>
    );
};

